import { ConnectCameraState } from '../../../../@types';

const initialState: ConnectCameraState = {
  vehicleRegistration: null,
  fuelCardFront: null,
  fuelCardBack: null,
};
export default initialState;
